import React, { useState } from 'react';
import { getRetailerLogo } from '../config/retailers';
import './RetailerLogo.css';

// Keep a readable identity underneath the image, including before it loads.
export default function RetailerLogo({ name, className = '', ...props }) {
  const src = getRetailerLogo(name);
  const [loadedSrc, setLoadedSrc] = useState(null);
  const [failedSrc, setFailedSrc] = useState(null);
  return <span className="ab-retailer-logo-wrap">
    <span className="ab-retailer-logo-name" aria-hidden={loadedSrc === src && failedSrc !== src ? true : undefined} style={{ visibility: loadedSrc === src && failedSrc !== src ? 'hidden' : 'visible' }}>{name}</span>
    {src && failedSrc !== src && <img {...props} src={src} alt={name} data-retailer={name} className={`ab-retailer-logo-image ${className}`} onLoad={() => setLoadedSrc(src)} onError={() => setFailedSrc(src)} />}
  </span>;
}
